

import React from 'react'
import { DetailBoxWrapper } from './style';
import editIcon from '../../../images/edit.svg';

function LeadBox({ children, heading = "", onClock = () => { } }) {
  return (
    <DetailBoxWrapper>
      <div className="header font-bold text-[#163A7A]">
        <h2>{heading}</h2>
      </div>
      <div className="main w-full">
        {children}

      </div>

    </DetailBoxWrapper>
  )
}

export default LeadBox;